import { IFeedbackListResponse, IFeedbackRequestParams } from 'models';
import { toQueryString } from 'utils';
import { apiVersion } from './apis.const';
import { transformResponse } from './apis.util';
import { baseApi } from './base.api';

/**
 * API Urls
 */

const feedbackUrl = (orgSlug: string) => `/${orgSlug}/${apiVersion}/feedback`;

/**
 * Create APIs
 */
export const feedbackApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchFeedbacks: build.query<FetchFeedbacksRes, FetchFeedbacksReq>({
      query: ({ orgSlug, params }) => {
        const qs = toQueryString(params);

        return {
          url: `${feedbackUrl(orgSlug)}${qs ? `?${qs}` : ''}`,
        };
      },
      transformResponse,
    }),
  }),
});

/**
 * Hooks
 */
export const { useFetchFeedbacksQuery } = feedbackApi;

/**
 * Types
 */
type FetchFeedbacksRes = IFeedbackListResponse;
type FetchFeedbacksReq = {
  orgSlug: string;
  params: IFeedbackRequestParams;
};
